module.exports = __webpack_public_path__ + "static/media/bird-droppings.d7b4ae91.gif";